/**
 * Help API -- fetches the static user manual rendered server-side.
 *
 * Endpoint: GET /dm-api/help/manual -> {success, data:{markdown, sections, length}}
 */
import { dmClient } from './dmClient';

export async function fetchUserManual() {
  const { data } = await dmClient.get('/help/manual');
  return data;
}

export async function fetchUserManualSections() {
  const { data } = await dmClient.get('/help/manual/sections');
  return data;
}
